package one.healthium.db.di

import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.async
import one.healthium.db.DatabaseFactory
import one.healthium.db.DriverFactory
import one.healthium.db.dao.DailyTasksDao
import one.healthium.db.dao.FoodDao
import one.healthium.db.dao.SavedContentDao
import one.healthium.db.dao.ShoppingListDataDao
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

val appDatabaseModule = module {
    includes(appDatabasePlatformModule())

    single {
        val driverFactory = get<DriverFactory>()
        GlobalScope.async {
            DatabaseFactory.createDatabase(driverFactory)
        }
    }
    singleOf(::DailyTasksDao)
    singleOf(::FoodDao)
    singleOf(::ShoppingListDataDao)
    singleOf(::SavedContentDao)
}
